/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
export let MapUtils;
(function (_MapUtils) {
  function mapValues(original, mapper) {
    const result = new Map();
    for (const [key, value] of original.entries()) {
      result.set(key, mapper(value, key));
    }
    return result;
  }
  _MapUtils.mapValues = mapValues;
  function invert(original) {
    const result = new Map();
    for (const [key, value] of original.entries()) {
      result.set(value, key);
    }
    return result;
  }
  _MapUtils.invert = invert;
  function filterToKeys(map, keys) {
    const currentKeys = new Set(map.keys());
    const keysToDelete = currentKeys.difference(keys);
    for (const key of keysToDelete) {
      map.delete(key);
    }
  }
  _MapUtils.filterToKeys = filterToKeys;
})(MapUtils || (MapUtils = {}));
//# sourceMappingURL=MapUtils.js.map
